import { render, staticRenderFns } from "./DialogPetitionConsentDetail.vue?vue&type=template&id=842aecaa&"
import script from "./DialogPetitionConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogPetitionConsentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports